// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DetalleProceso__DetalleProceso__2L_h7{\r\n    display: flex; \r\n    justify-content: space-around;\r\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DetalleProceso": "DetalleProceso__DetalleProceso__2L_h7"
};
export default ___CSS_LOADER_EXPORT___;
